import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Tags from "@yaireo/tagify/dist/react.tagify";
import "@yaireo/tagify/dist/tagify.css";
import Spinner from "../../component/loadingbar/Spinner";

const AddViewAbuse = () => {
  //----------------------------------------------- State Management -----------------------------------------------
  const [abuseWord, setAbuseWord] = useState([]);
  const [abuseWordList, setAbuseWordList] = useState([]);
  const [abuseChanged, setAbuseChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = config.token;

  const handleAbuseChange = useCallback((e) => {
    setAbuseWord(e.detail.tagify.value.map((a) => a.value));
    setAbuseChanged(true);
  }, []);

  //----------------------------------------------- Create / Add Abuse   -------------------------------------------------R

  const handleAddAbuse = async (e) => {
    e.preventDefault();

    // --- Require field validation ---

    if (abuseWord.length === 0) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return; // Stop form submission
    }
    if (!token) {
      triggerNotification("error", "Please login to create a teacher");
      return;
    }
    try {
      // Fetch teacher list
      fetch(`${config.host_url}abusive-words`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({
          word: abuseWord,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Abusive words updated successfully"
            );
            setAbuseWord([]);
            fetchAbuse();
          } else if (data.status === 401) {
            triggerNotification("error", "Please login to add abuse");
          } else {
            triggerNotification("error", "Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error adding abuse:", error);
          triggerNotification("error", "Error adding abuse");
        });
    } catch (error) {
      triggerNotification(
        "error",
        "Some Error Occurred!! Please try again later"
      );
    }
  };

  //----------------------------------------------- select / view Abuse   -------------------------------------------------R
  // Fetch all Abuse
  const fetchAbuse = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}abusive-words`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setAbuseWordList(data.data.map((tag) => tag.word));
            setAbuseChanged(false);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching abusive words.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAbuse();
  }, [token]);

  return (
    <>
      <Breadcrumb txt="Manage Abuse" subpath={["Add & Show Abuse"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Abuse Words</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body mb-10">
              <form>
                <Tags
                  value={abuseWordList}
                  placeholder="Enter Abusive Words"
                  onChange={handleAbuseChange}
                />
                {/* submit */}
                {abuseChanged ? (
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleAddAbuse}
                    >
                      Submit
                    </button>
                  </div>
                ) : (
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleAddAbuse}
                      disabled
                    >
                      Submit
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddViewAbuse;
